"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
// Component
var DisambiguationModal_1 = __importDefault(require("./DisambiguationModal"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
var _utils_1 = require("@src/actions/_utils");
// Stores
var store_1 = __importDefault(require("@src/store"));
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var UserSaysStore_1 = __importDefault(require("@src/stores/UserSaysStore"));
// Constants
var const_1 = require("@src/const");
var DisambiguationModalWrapper = function (_a) {
    var _b, _c;
    var isActive = _a.isActive, onClose = _a.onClose, sentenceId = _a.sentenceId;
    var _d = react_1.useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = react_1.useState({}), disambiguationData = _e[0], setDisambiguationData = _e[1];
    var meta = CommonStore_1["default"].getMetaTags();
    var languagesCodeToTitle = CommonStore_1["default"].getLanguagesCodeToTitle();
    react_1.useEffect(function () {
        // Fetch Disambiguation Texts Data
        BotActions_1.getDisambiguationTexts(meta.domain.id, sentenceId, function () {
            setDisambiguationData(UserSaysStore_1["default"].getDisambiguationTexts());
            setIsLoading(false);
        });
    }, [(_b = meta === null || meta === void 0 ? void 0 : meta.domain) === null || _b === void 0 ? void 0 : _b.id, (_c = meta === null || meta === void 0 ? void 0 : meta.step) === null || _c === void 0 ? void 0 : _c.id]);
    var triggerMixpanelEvents = function (data) {
        var mixPanelTracker = store_1["default"].getMixPanel();
        var meta = CommonStore_1["default"].getMetaTags();
        Object.keys(data).map(function (language) {
            Object.keys(data[language]).map(function (script) {
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.DISAMBIGUATION.MESSAGE_EDITED,
                    payload: {
                        'Bot ID': meta.domain.id,
                        'Bot Name': meta.domain.title,
                        Business: meta.domain.client,
                        'CAS Name': _utils_1.CASName(),
                        Language: languagesCodeToTitle[script + "|" + language],
                        'New Message': data[language][script],
                    },
                });
            });
        });
    };
    var onSave = function (data, callback) {
        BotActions_1.saveDisambiguationTexts(meta.domain.id, sentenceId, data, function () {
            triggerMixpanelEvents(data);
            setDisambiguationData(UserSaysStore_1["default"].getDisambiguationTexts());
            if (callback)
                callback();
        });
    };
    return (react_1["default"].createElement(DisambiguationModal_1["default"], { isActive: isActive, isLoading: isLoading, onClose: onClose, onSave: onSave, disambiguationData: disambiguationData, languagesCodeToTitle: languagesCodeToTitle }));
};
exports["default"] = DisambiguationModalWrapper;
